import React, { useCallback, useEffect, useState } from 'react'
import { CRow, CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import CommunityPostsService from 'src/service/CommunityPostsService'
import CommunityPostsTable from './CommunityPostsTable'

const CommunityTopPlayers = () => {
  const [posts, setPosts] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})

  const postType = 'round_top_players'
  const title = 'Top Players Posts'

  const fetchPosts = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await CommunityPostsService.getCommunityPosts(
        postType,
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setPosts(result.data)
    } catch (error) {
      console.error('Error fetching community posts:', error)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchPosts()
  }, [fetchPosts])

  return (
    <CRow>
      <CCard className="mb-4">
        <CCardHeader>
          <strong>{title}</strong>
        </CCardHeader>
        <CCardBody>
          <CommunityPostsTable
            posts={posts}
            postType={postType}
            setPosts={setPosts}
            fetchPosts={fetchPosts}
            setActivePage={setActivePage}
            setItemsPerPage={setItemsPerPage}
            setColumnFilter={setColumnFilter}
            setColumnSorter={setColumnSorter}
            itemsPerPage={itemsPerPage}
            activePage={activePage}
            columnFilter={columnFilter}
            columnSorter={columnSorter}
          />
        </CCardBody>
      </CCard>
    </CRow>
  )
}

export default CommunityTopPlayers
